import type { OptimizationRoute, OptimizationSuccessPayload, OptimizedWaypoint } from '../servicebus/optimization';
import { ObjectFactory } from './object.factory';

export class OptimizedWaypointFactory extends ObjectFactory<OptimizedWaypoint> {
  protected getDefaults(): OptimizedWaypoint {
    return {
      estimatedArrivalTime: undefined,
      estimatedDepartureTime: undefined,
      fulfilledConstraints: undefined,
      id: 'waypoint-1',
      sequence: 0,
    };
  }
}

export const optimizedWaypointFactory = new OptimizedWaypointFactory();

export class OptimizationRouteFactory extends ObjectFactory<OptimizationRoute> {
  protected getDefaults(): OptimizationRoute {
    return {
      departureTime: undefined,
      legs: undefined,
      totalDistanceInMeters: undefined,
      totalTimeInSeconds: undefined,
      vehicleId: 'vehicle-1',
      waypoints: [optimizedWaypointFactory.build()],
    };
  }
}

export const optimizationRouteFactory = new OptimizationRouteFactory();

export class OptimizationSuccessPayloadFactory extends ObjectFactory<OptimizationSuccessPayload> {
  protected getDefaults(): OptimizationSuccessPayload {
    return {
      engine: 'here',
      routes: [optimizationRouteFactory.build()],
      totalDistanceInMeters: undefined,
      totalTimeInSeconds: undefined,
      unassignedWaypoints: undefined,
    };
  }
}

export const optimizationSuccessPayloadFactory = new OptimizationSuccessPayloadFactory();
